export default "__VITE_ASSET__j3aJc0pE__"